<template>
  <section>
  	 <el-row class="total">
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-question sicon c1"></i>
        <span class="tjContent">
          <div>换出日活</div>
          <div
            class="numText t1"
          >{{visit_uv_out}}</div>
        </span>
      </el-card>
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-success sicon c2"></i>
        <span class="tjContent">
          <div>换入日活</div>
          <div
            class="numText t2"
          >{{visit_uv_in}}</div>
        </span>
      </el-card>
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-news sicon c3"></i>
        <span class="tjContent">
          <div>顺逆差</div>
          <div class="numText t3">{{diff}}</div>
        </span>
      </el-card>
      </el-card>
     </el-row>
    <!-- 统计文字 -->
    <el-row style="padding:15px;background:#fff">
    	
      <el-col :sm="24" :xs="24" >
        <el-row :gutter="10">
        	<el-button class="xs24" type="primary" plain @click="changeDate(1)">昨天</el-button>
        	<el-button class="xs24" type="primary" plain @click="changeDate(2)">前天</el-button>
          <el-button class="xs24" type="primary" plain @click="changeDate(7)">最近7天</el-button>
          <el-button class="xs24" type="primary" plain @click="changeDate(31)">最近31天</el-button>
          <el-date-picker
          	class="xs24"
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="今天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyyMMdd"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <el-select  v-model="pdata.company_id"  clearable filterable placeholder="请选择对应公司">
              <el-option v-for="item in companys" :key="item.company_id" :label="item.company_name" :value="item.company_id"></el-option>
          </el-select>
        </el-row>
      </el-col>
      <!--<el-col :sm="8" :xs="24">
        <div style="float:right;text-align: right;">
          <el-row :gutter="10">
            <searchApp  class="xs24" @getid="changeId" compare="issued" :pholder="pholder"></searchApp>
          </el-row>
        </div>
      </el-col>-->
    </el-row>
    




    <el-table :data="list" style="width: 100%;min-width:1200px"   stripe    @expand-change="expands" class="selfTable"   v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    	<el-table-column type="expand" prop="name" v-if="dateVal[0]!==dateVal[1]" style="padding: 0;" class="expandd">
		        <template slot-scope="s">
		           <el-table :data="s.row.exData" :show-header="false" >
		           	  <el-table-column prop="d_date" label="" align="center"  width="48px">
		           	  	 <template slot-scope="scope" >
					                <span>&nbsp;</span>
					            </template>
		           	  </el-table-column>
		              <el-table-column prop="d_date" label="日期" align="center" ></el-table-column>
		              <el-table-column prop="visit_uv_out" show-overflow-tooltip label="换出日活" align="center" ></el-table-column>
									<el-table-column prop="visit_uv_in" show-overflow-tooltip label="换入日活" align="center"></el-table-column>
									<el-table-column prop="diff" show-overflow-tooltip label="顺逆差" align="center" ></el-table-column> 
									<el-table-column prop="" label="操作" align="center" >
						      	 <template slot-scope="scope">
						        	<span>&nbsp;</span>
						        </template>
						      </el-table-column>
		           </el-table>
		        </template>
		      </el-table-column>
    	<el-table-column prop="company_name" label="换量公司" align="center" ></el-table-column>
      <el-table-column prop="visit_uv_out" label="换出日活" align="center"  sortable :sort-method="(a,b)=>{return (a.visit_uv_out-0)-(b.visit_uv_out-0)}"></el-table-column>
      <el-table-column prop="visit_uv_in" label="换入日活" align="center" sortable :sort-method="(a,b)=>{return (a.visit_uv_in-0)-(b.visit_uv_in-0)}"></el-table-column>
      <el-table-column prop="diff" label="顺逆差" align="center" sortable :sort-method="(a,b)=>{return (a.diff-0)-(b.diff-0)}"></el-table-column>
      <el-table-column prop="" label="操作" align="center" >
      	 <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="$router.push({name:'扣量日报详情',params:{company_id:scope.row.company_id},query:{sdate:pdata.sdate,edate:pdata.edate}})">详情</el-button>
        </template>
      </el-table-column>
      
	  	
    </el-table>

  </section>
</template>

<script>
import { getExchangeDaily, getAppid , getIssuedAldCompany,getExchangeDailyDay} from "../../api/api";

export default {
  data() {
    return {
      pdata: {
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        company_id:'',  
        // sdate: "2019-04-15",
        // edate: "2019-04-15",
      },
      loading:false,
      companys: [],
      maxPage: 1,
      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000 * 7 * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      list:[], //所有数据
      visit_uv_out:0,
      visit_uv_in:0,
      diff:0,
    };
  },
  watch: {
  	'pdata.company_id':{
  		 handler(n, o) {
      
        this.getList();
       
      },
      deep: true
  	},
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    }
  },
  methods: {
  	expands(r, es) {
  		this.loading=true;
      var isshou = false;
      if (es.length > 0) {
        es.forEach(v => {
          if (v.issued_app_id == r.issued_app_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = `company_id=${r.company_id}&sdate=${this.dateVal[0]}&edate=${this.dateVal[1]}`;
				
        getExchangeDailyDay(p, this.$cookie.getCookie("login")).then(res => {
        	this.loading=false;
          if (res.code == 200) {
          	if(res.data&&res.data.length>0){
          		 r.exData = res.data;
            	 this.$forceUpdate();
          	}           
          }        
        });
      }
      else{
      	this.loading=false;
      }
    },
    getList() {
    	this.loading=true;
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getExchangeDaily(p, this.$cookie.getCookie("login")).then(res => {
      			this.loading=false;
				 	  this.list=res.data;
          	this.visit_uv_out=0;
			      this.visit_uv_in=0;
			      this.diff=0;
		        if (res.code == 200) {
		           if(res.data&&res.data.length>0){
		          	 res.data.forEach((v,i) => {
		          	 		this.visit_uv_in = this.visit_uv_in + parseInt( v.visit_uv_in );
			          		this.visit_uv_out = this.visit_uv_out + parseInt( v.visit_uv_out );
			          		this.diff = this.diff + parseInt( v.diff );
			            	v.keyid='key'+i;
			              v.exData = [];
			            });
			            this.list=res.data;
		          }
		          else{
		          		this.list=[];
		          }          
		        }
      });
      
    },
    getCompany(){
    	var p = "";
     
    	getIssuedAldCompany(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	
          if(res.data&&res.data.length>0){
	            this.companys=res.data;
          }
          else{
          		this.companys=[];
          }
          
          
        }
      });
    },

    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
  },

  mounted() {

    if (Object.keys(this.$route.params).length > 0) {
      this.pdata.sdate = this.$route.params.sdate;
      this.pdata.edate = this.$route.params.edate;
    }
    this.getList();
    this.getCompany();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
</style>


<style scoped="scoped">
	.red{
		color: #FF0000;
	}
</style>


// WEBPACK FOOTER //
// exchangeDaily.vue?2e6d2683